import { useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useSubjects } from "@/lib/buddy";

const inp = "w-full px-4 py-2.5 rounded-xl bg-white border border-[#D6CDB4] text-sm focus:outline-none focus:border-[#2C4A3E] mt-1";

export const AddSchoolItem = ({ today, onAdded }) => {
  const blank = { topic: "", subject_id: "math", course: "", date: today, due_time: "23:59", note: "" };
  const SUBJECTS = useSubjects();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(blank);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    try { await http.post("/planner/me/school-items", { ...f, due_time: f.due_time || null }); toast.success("Added to your planner"); setOpen(false); setF(blank); onAdded(); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="add-school-item-btn" className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#C87D53] text-white text-sm"><Plus className="w-4 h-4" /> Add school assignment</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#FDFBF7]" data-testid="add-school-item-dialog">
          <DialogTitle className="font-display text-2xl text-[#2C4A3E]">Add a school assignment</DialogTitle>
          <form onSubmit={save} className="space-y-3">
            <label className="block text-sm text-[#2C4A3E]">What is it?<input required minLength={2} maxLength={140} value={f.topic} onChange={set("topic")} placeholder="e.g. Workbook page 45" data-testid="school-item-topic" className={inp} /></label>
            <div className="grid grid-cols-2 gap-3">
              <label className="block text-sm text-[#2C4A3E]">Subject<select value={f.subject_id} onChange={set("subject_id")} data-testid="school-item-subject" className={inp}>{SUBJECTS.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}</select></label>
              <label className="block text-sm text-[#2C4A3E]">Class (optional)<input value={f.course} onChange={set("course")} maxLength={80} placeholder="e.g. Math 5" data-testid="school-item-course" className={inp} /></label>
              <label className="block text-sm text-[#2C4A3E]">Due date<input type="date" required value={f.date} onChange={set("date")} data-testid="school-item-date" className={inp} /></label>
              <label className="block text-sm text-[#2C4A3E]">Due time<input type="time" value={f.due_time} onChange={set("due_time")} data-testid="school-item-time" className={inp} /></label>
            </div>
            <label className="block text-sm text-[#2C4A3E]">Note (optional)<input value={f.note} onChange={set("note")} maxLength={300} data-testid="school-item-note" className={inp} /></label>
            <button data-testid="school-item-save" className="w-full py-3 rounded-full bg-[#2C4A3E] text-white">Add to my planner</button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
